module.exports = __webpack_public_path__ + "img/DE03671.1fbca5bb.png";